import { combineReducers } from '@ngrx/store';
import * as fromRmsSimulate from './simulate.reducer';
import * as fromRmsOrder from './order.reducer';
import * as fromRmsSimulateOP from './open-platform/simulate.reducer';
import * as fromRmsOrderOP from './open-platform/order.reducer';

export interface RmsSummaryState {
  rmsLegacySimulateState: fromRmsSimulate.SimulateState;
  rmsLegacyOrderState: fromRmsOrder.RmsOrderState;
  rmsOpenPlatformSimulateState: fromRmsSimulateOP.SimulateState;
  rmsOpenPlatformOrderState: fromRmsOrderOP.RmsOrderState;
}

export const reducers = combineReducers({
  rmsLegacySimulateState: fromRmsSimulate.simulateReducer,
  rmsLegacyOrderState: fromRmsOrder.orderReducer,
  rmsOpenPlatformSimulateState: fromRmsSimulateOP.simulateReducer,
  rmsOpenPlatformOrderState: fromRmsOrderOP.orderReducer,
});
